import { render, staticRenderFns } from "./EventContent.vue?vue&type=template&id=5ae0beca&"
import script from "./EventContent.vue?vue&type=script&lang=js&"
export * from "./EventContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports